// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../channels2022/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ui-dark .channels2022-template[data-v-1157eb04] .custom-select option{background:#010314}[data-v-1157eb04] select{cursor:pointer;border-radius:100px}[data-v-1157eb04] .modal-header{border-bottom:none;padding:2rem 2.5rem 0}[data-v-1157eb04] .modal-header h5{font-size:2rem}[data-v-1157eb04] .modal-body{padding:0 2.5rem 2.5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
